(function () {
  'use strict';
  const selector = '[data-poshaak-deferred-image], [data-poshaak-background], [data-poshaak-footer-background]';
  const watched = new WeakSet();
  const backgrounds = new Set();
  const mobile = window.matchMedia('(max-width: 720px)');

  function updateBackground(element) {
    const url = mobile.matches && element.dataset.backgroundMobile
      ? element.dataset.backgroundMobile : element.dataset.backgroundDesktop;
    if (url) element.style.backgroundImage = 'url(' + JSON.stringify(url) + ')';
    element.classList.add('Image--lazyLoaded', 'is-background-loaded');
  }

  function load(element) {
    if (!element || element.dataset.poshaakImageLoaded === 'true') return;
    element.dataset.poshaakImageLoaded = 'true';
    if (observer) observer.unobserve(element);
    if (element.hasAttribute('data-poshaak-footer-background')) {
      if (element.dataset.backgroundDesktop) element.style.setProperty('--poshaak-footer-desktop', 'url(' + JSON.stringify(element.dataset.backgroundDesktop) + ')');
      if (element.dataset.backgroundMobile) element.style.setProperty('--poshaak-footer-mobile', 'url(' + JSON.stringify(element.dataset.backgroundMobile) + ')');
      return;
    }
    if (element.hasAttribute('data-poshaak-background')) {
      backgrounds.add(element);
      updateBackground(element);
      return;
    }
    const nodes = [element].concat(Array.from(element.querySelectorAll('source, img')));
    nodes.filter(node => node.tagName === 'SOURCE').forEach(node => {
      if (node.dataset.srcset) { node.srcset = node.dataset.srcset; node.removeAttribute('data-srcset'); }
    });
    nodes.filter(node => node.tagName === 'IMG').forEach(node => {
      if (!node.dataset.src && !node.dataset.srcset) return;
      node.loading = 'eager';
      if (node.dataset.srcset) { node.srcset = node.dataset.srcset; node.removeAttribute('data-srcset'); }
      if (node.dataset.src) { node.src = node.dataset.src; node.removeAttribute('data-src'); }
    });
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) load(entry.target); });
  }, {rootMargin: '150px', threshold: 0}) : null;

  function register(scope) {
    if (!scope || !scope.querySelectorAll) return;
    const elements = Array.from(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) elements.unshift(scope);
    elements.forEach(element => {
      if (watched.has(element) || element.dataset.poshaakImageLoaded === 'true') return;
      watched.add(element);
      if (observer) observer.observe(element); else load(element);
    });
  }

  function init() {
    register(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(register));
    }).observe(document.body, {childList: true, subtree: true});
  }
  window.poshaakLoadDeferredImage = load;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => register(event.target));
  mobile.addEventListener('change', () => backgrounds.forEach(element => {
    if (element.isConnected) updateBackground(element); else backgrounds.delete(element);
  }));
}());
